import { SkillsTab } from './SkillsTab';

export function SkillsModal({ onClose }: { onClose: () => void }) {
  return (
    <div
      className="modal-backdrop"
      role="dialog"
      aria-modal="true"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="modal">
        <header className="modal-header">
          <h2>Skills</h2>
          <button className="modal-close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </header>
        <section className="modal-body">
          <SkillsTab />
        </section>
        <footer className="modal-footer muted small">
          Shortcuts: <kbd>Esc</kbd> close · <kbd>Cmd</kbd>/<kbd>Ctrl</kbd>
          +<kbd>K</kbd> toggle Skills
        </footer>
      </div>
    </div>
  );
}
